import { render, staticRenderFns } from "./OrticTableHeader.vue?vue&type=template&id=366ee876&"
import script from "./OrticTableHeader.vue?vue&type=script&lang=js&"
export * from "./OrticTableHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports